import React from "react"
import Flatpickr from "react-flatpickr"
import persistentUniqueId from "../utils/persistentUniqueId"
import { Dutch } from "flatpickr/dist/l10n/nl.js"

const Picker = ({ value, defaultValue, inputRef, name, ...props }) => {
  return (
    <input
      {...props}
      className="form-field__text__input flatpickr-1"
      defaultValue={defaultValue}
      ref={inputRef}
      name={name}
    />
  )
}

const Datepicker = persistentUniqueId("uniqueId")(
  ({ uniqueId, children, type, inline, wider, name, onChange }) => {
    return (
      <div
        className={
          inline ? "form-field--inline" + (wider ? "--wider" : "") : ""
        }
      >
        <label htmlFor={uniqueId("input")} className="form-field__label">
          {children}
        </label>
        <div className="form-field__text">
          <Flatpickr
            onChange={onChange}
            render={({ defaultValue, value, ...props }, ref) => {
              return (
                <Picker
                  defaultValue={defaultValue}
                  inputRef={ref}
                  name={name}
                />
              )
            }}
            options={{
              locale: Dutch,
              monthSelectorType: "static",
              dateFormat: "d-m-Y",
              minDate: (new Date().getHours() <= 12) ? new Date() : new Date(+new Date() + 86400000),
              disable: [
                function (date) {
                  // return true to disable
                  return date.getDay() === 0
                },
              ]
            }}
          />
        </div>
      </div>
    )
  }
)

export default Datepicker
